import { type FC } from 'react';
import { ProductAttributeInterface } from '../../../../../../../Interface/ProductAttribute';
import ClearanceDescription from '../../../../../ClearanceDescription/ClearanceDescription';
import { FilterState } from '../../../../../../Context/ProductsFilterContext';
import OverflowedTextTooltip from '../../../../../OverflowedTextTooltip/OverflowedTextTooltip';
import { cleanClearanceReason } from '../../../../../../Helper/flavourDiscount';
import style from './FlavourName.module.scss?module';
import clsx from 'clsx';

type FlavourNamePropsT = {
  isClearance: boolean;
  productSizeName: ProductAttributeInterface['product_size']['name'];
  combinedDescription1: ProductAttributeInterface['combined_description_1'];
  view: FilterState['view'];
};

const FlavourName: FC<FlavourNamePropsT> = ({
  productSizeName,
  isClearance,
  combinedDescription1,
  view,
}) => {
  const clearanceDescription = cleanClearanceReason(combinedDescription1);

  return (
    <div>
      <div>
        {' '}
        {view === 'table' ? (
          <OverflowedTextTooltip text={productSizeName} />
        ) : (
          productSizeName
        )}
      </div>
      <div>
        {isClearance && clearanceDescription ? (
          <ClearanceDescription>
            {view === 'table' ? (
              <OverflowedTextTooltip
                className={clsx(style.ClearanceDescriptionWrapper)}
                text={clearanceDescription}
              />
            ) : (
              clearanceDescription
            )}
          </ClearanceDescription>
        ) : null}
      </div>
    </div>
  );
};

export default FlavourName;
